import React, { useEffect, useRef } from "react";
import cssClasses from "./PrivacyPolicy.module.css";
import { useDispatch } from "react-redux";
import actions from "../../Redux Store/actions";
export default function PrivacyPolicy() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(actions.activeMenu("help"));
  }, []);
  return (
    <div className={cssClasses.wrapperPage}>
      <div className={cssClasses.title}>Introduction to Privacy Policy</div>
      <div className={cssClasses.content}>
        This privacy policy (the "PRIVACY POLICY") applies to your use of the
        website of Vilas Javdekar Developers and it’s associates hosted at
        vjerp.com, the Services (as defined under the VJESLLP "Terms of Use")
        and VJESLLP applications on mobile platforms (Android, Blackberry,
        Windows Phone, iOS etc.) (collectively ("VJESLLP " or "WEBSITE.
        <br></br>
        <br></br>
        The terms "WE", "OUR" and "US" refer to Vilas Javdekar Developers and
        it’s associates and the terms "YOU", "YOUR" and "USER" refer to you, as
        a user of VJESLLP. The term "PERSONAL INFORMATION" means information
        that you provide to us which personally identifies you to be contacted
        or identified, such as your name, phone number, email address, and any
        other data that is tied to such information. Our practices and
        procedures in relation to the collection and use of Personal Information
        have been set-out below in order to ensure safe usage of the Website for
        you.
        <br></br>
        <br></br>
        We have implemented reasonable security practices and procedures that
        are commensurate with the information assets being protected and with
        the nature of our business. While we try our best to provide security
        that is better than the industry standards, because of the inherent
        vulnerabilities of the internet, we cannot ensure or warrant complete
        security of all information that is being transmitted to us by you. By
        visiting this Website, you agree and acknowledge to be bound by this
        Privacy Policy and you hereby consent that we will collect, use, process
        and share your Personal Information in the manner set out herein below.
        If you do not agree with these terms, do not use the Website.
        <br></br>
        <br></br>
        It is clarified that the terms and conditions that are provided
        separately, form an integral part of your use of this Website and should
        be read in conjunction with this Privacy Policy.
        <br></br>
        <br></br>
        <div className={cssClasses.title}>
          Information we collect and how we use it
        </div>
        We collect, receive and store your Personal Information. If you provide
        your third-party account credentials ("THIRD PARTY ACCOUNT INFORMATION")
        to us, you understand that some content and information in those
        accounts may be transmitted to your account with us if you authorise
        such transmissions and that Third Party Account Information transmitted
        to us shall be covered by this Privacy Policy. You may opt to not
        provide us with certain information, however that will restrict you from
        registering with us or availing some of our features and services.
        <br></br>
        <br></br>
        We use commercially reasonable efforts to ensure that the collection of
        Personal Information is limited to that which is necessary to fulfill
        the purposes identified below. If we use or plan to use your information
        in a manner different than the purpose for which it is collected, then
        we will ask you for your consent prior to such use. The Personal
        Information collected will be used only for the purpose of enabling you
        to use the services provided by us, to help promote a safe service,
        calibrate consumer interest in our products and services, inform you
        about online offers and updates, troubleshoot problems, customize User
        experience, detect and protect us against error, fraud and other
        criminal activity, collect money, enforce our terms and conditions, and
        as otherwise described to you at the time of collection of such
        information.
        <br></br>
        <br></br>
        We also store customer information of customers such as address, mobile
        number, Third Party Wallet details, Card Details and email address
        making payments through online payment checkouts. However, VJESLLP is
        not liable in any way for any misuse of this information by the business
        or people related to the businesses to whom the information is shared by
        the customer.
        <br></br>
        <br></br>
        <div className={cssClasses.title}>Transfer of information</div>
        {/* <br></br>
        <br></br> */}
        We do not share your Personal Information with any third party apart
        from financial institutions such as banks, RBI or other regulatory
        agencies (as may be required) and to provide you with services that we
        offer through VJESLLP, conduct quality assurance testing, facilitate
        creation of accounts, provide technical and customer support, or provide
        specific services, such as synchronization of your contacts with other
        software applications, in accordance with your instructions. These third
        parties are required not to use your Personal Information other than to
        provide the services requested by you.
        <br></br>
        <br></br>
        We may share your Personal Information with our parent company,
        subsidiaries, joint ventures, or other companies under a common control
        (collectively, the "AFFILIATES") that we may have now or in the future,
        in which case we will require them to honor this Privacy Policy. If
        another company acquires our company or our assets, that company will
        possess your Personal Information, and will assume the rights and
        obligations with respect to that information as described in this
        Privacy Policy. We may disclose your Personal Information to third
        parties in a good faith belief that such disclosure is reasonably
        necessary to (a) take action regarding suspected illegal activities; (b)
        enforce or apply our terms and conditions and Privacy Policy; (c) comply
        with legal process, such as a search warrant, subpoena, statute, or
        court order; or (d) protect our rights, reputation, and property, or
        that of our Users, Affiliates, or the public. Please note that we are
        not required to question or contest the validity of any search warrant,
        subpoena or other similar governmental request that we receive.
        <br></br>
        <br></br>
        We may disclose information in the aggregate to third parties relating
        to User behavior in connection with actual or prospective business
        relationship with those third parties, such as advertisers and content
        distributors. For example, we may disclose the number of Users that have
        been exposed to, or clicked on, advertising banners.
        <br></br>
        <br></br>
        <div className={cssClasses.title}>Links</div>
        {/* <br></br>
        <br></br> */}
        References on this Website to any names, marks, products or services of
        third parties or hyperlinks to third party websites or information are
        provided solely for your convenience and do not in any way constitute or
        imply our endorsement, sponsorship or recommendation of the third party,
        information, product or service. Except as set forth herein, we do not
        share your Personal Information with those third parties, and are not
        responsible for their privacy practices. We suggest you read the privacy
        policies on all such third party websites.
        <br></br>
        <br></br>
        <div className={cssClasses.title}>
          User access of Personal Information
        </div>
        {/* <br></br>
        <br></br> */}
        As a registered VJESLLP User, you can modify some of your Personal
        Information and your privacy preferences by accessing the "Account"
        section of this Website.
        <br></br>
        <br></br>
        <div className={cssClasses.title}>Security</div>
        {/* <br></br>
        <br></br> */}
        Your account is password protected. We use industry standard measures to
        protect the Personal Information that is stored in our database. We
        follow industry standard best practices on Information Security, as also
        mentioned in our website. If you have any questions about the security
        on VJESLLP, please contact us{" "}
        <a href="enquiry@javdekars.com" rel="noreferrer" target={'_blank'}>enquiry@javdekars.com</a>
        <br></br>
        <br></br>
        You hereby acknowledge that VJESLLP is not responsible for any
        intercepted information sent via the internet, and you hereby release us
        from any and all claims arising out of or related to the use of
        intercepted information in any unauthorized manner.
        <br></br>
        <br></br>
        <div className={cssClasses.title}>
          Terms and modifications to this Privacy Policy
        </div>
        {/* <br></br>
        <br></br> */}
        Our Privacy Policy is subject to change at any time without notice. To
        make sure you are aware of any changes, please review this policy
        periodically. These changes will be effective immediately on the Users
        of VJESLLP. Please note that at all times you are responsible for
        updating your Personal Information, including to provide us with your
        most current e-mail address.
        <br></br>
        <br></br>
        If you do not wish to permit changes in our use of your Personal
        Information, you must notify us promptly that you wish to deactivate
        your account with us. Continued use of VJESLLP after any change/
        amendment to this Privacy Policy shall indicate your acknowledgement of
        such changes and agreement to be bound by the terms and conditions of
        such changes.
        <br></br>
        <br></br>
        <div className={cssClasses.title}>Applicable law</div>
        Your use of this Website will be governed by and construed in accordance
        with the laws of India. The Users agree that any legal action or
        proceedings arising out of your use may be brought exclusively in the
        competent courts/ tribunals having jurisdiction in Bengaluru in India
        and irrevocably submit themselves to the jurisdiction of such courts/
        tribunals.
        <br></br>
        <br></br>
        <div className={cssClasses.title}>
          Complaints and Grievance Redressal
        </div>
        {/* <br></br>
        <br></br> */}
        If you contact us to provide feedback, register a complaint, or ask a
        question, we will record any Personal Information and other content that
        you provide in your communication so that we can effectively respond to
        your communication. Any complaints or concerns in relation to your
        Personal Information or content of this Website or any dispute or breach
        of confidentiality or any proprietary rights of User during use of the
        Website or any intellectual property of any User should be immediately
        informed to the Grievance cum Nodal Officer at the co-ordinates
        mentioned below in writing or by way of raising a grievance ticket
        through the hyperlink mentioned below:
        <br></br>
        <br></br>
        <div className={cssClasses.title}>Grievance officer</div>
        {/* <br></br>
        <br></br> */}
        Mr. Rohit Jadhav
        <br></br>
        Vilas Javdekar Engineering Services LLP
        <br></br>
        306, Siddharth Towers, Sangam Press Road, Kothrud, Pune 411 038
        <br></br>
        Contact No.: +91 20 6764 8000 / 01 / 02
      </div>
    </div>
  );
}
